const AgreementSignBlockStore = {
    featureImage: 'marketing_site/lp/proposal/contract.png',
    quoteAvatar: 'marketing_site/proposals_page/julia-mattox.png'
};

export default AgreementSignBlockStore;
